import { render, staticRenderFns } from "./commonEmpty.vue?vue&type=template&id=1fdb403e&scoped=true"
import script from "./commonEmpty.vue?vue&type=script&lang=js"
export * from "./commonEmpty.vue?vue&type=script&lang=js"
import style0 from "./commonEmpty.vue?vue&type=style&index=0&id=1fdb403e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdb403e",
  null
  
)

export default component.exports